<template>
  <div class="filters" :class="{ active: show }">
    <div class="scroll-zone" ref="scrollzone">
      <div class="flex-between">
        <h4 class="label">Task Filters</h4>
        <a class="close" @click="close()"
          ><i class="material-icons">clear</i></a
        >
      </div>

<!--      <label>People</label>-->
<!--      <multi-select-->
<!--        type="teamMembers"-->
<!--        :values="action_filters.assigneeId"-->
<!--        :onChange="handleChange"-->
<!--        label="team member"-->
<!--        labelPlural="team members"-->
<!--        includeSearch-->
<!--      />-->

      <label>Types</label>
      <multi-select
        type="action_type"
        :values="action_filters.type"
        :onChange="handleChange"
        label="type"
        labelPlural="types"
      />

      <label>Date range</label>
      <datepicker
        :value="selectedDates"
        mode="range"
        :onChange="handleDateChange"
      />

      <label>Documents</label>
      <b-form-group>
        <b-form-radio
          class="radio"
          v-model="action_filters.existLinkedDocs"
          name="docs-radio"
          :value="false"
          >All tasks</b-form-radio
        >
        <b-form-radio
          class="radio"
          v-model="action_filters.existLinkedDocs"
          name="docs-radio"
          :value="true"
          >Tasks with documents</b-form-radio
        >
      </b-form-group>

      <label>Project</label>
      <multi-select
        type="projects"
        :values="action_filters.projectId"
        :onChange="handleChange"
        label="project"
        labelPlural="projects"
      />
    </div>

    <div class="apply-filters">
      <a class="button" @click="applyFilters()">Apply</a>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from './Datepicker';
import MultiSelect from './MultiSelect';

export default {
  name: 'ActionFilters',
  data() {
    return {
      selectedDates: '',
      action_filters: this.$store.getters.action_filters,
    };
  },
  props: {
    onApply: Function,
  },
  components: {
    'multi-select': MultiSelect,
    datepicker: Datepicker,
  },
  methods: {
    handleDateChange(dates) {
      this.selectedDates = dates;
    },
    handleChange(val, kind) {
      if (kind === 'teamMembers') {
        kind = 'assigneeId';
      }

      if (kind === 'action_type') {
        kind = 'type';
      }

      if (kind === 'projects') {
        kind = 'projectId';
      }

      if (val === 'All') {
        this.action_filters[kind] = ['All'];
        return;
      }

      // they've picked something other than All, so filter All out
      this.action_filters[kind] = this.action_filters[kind].filter(
        s => s !== 'All'
      );

      // if they've picked something we already have, deselect it
      if (this.action_filters[kind].includes(val)) {
        this.action_filters[kind] = this.action_filters[kind].filter(
          s => s !== val
        );

        if (!this.action_filters[kind].length) {
          this.action_filters[kind] = ['All'];
        }

        return;
      }

      this.action_filters[kind].push(val);
    },
    applyFilters() {
      this.$store.dispatch('setActionFilters', this.action_filters);

      this.onApply();
      this.close();
    },
    close() {
      this.$store.dispatch('setActionFiltersVisible', false);
    },
    reset() {
      this.$store.dispatch('resetActionFilters');
    },
  },
  computed: {
    show() {
      return this.$store.getters.action_filters_visible;
    },
    stored_filters() {
      return JSON.parse(JSON.stringify(this.$store.getters.action_filters));
    },
    filtered_start_date() {
      if (
        !this.action_filters ||
        !this.action_filters.dates ||
        !this.action_filters.dates.start
      )
        return '';
      return this.action_filters.dates.start;
    },
    filtered_end_date() {
      if (
        !this.action_filters ||
        !this.action_filters.dates ||
        !this.action_filters.dates.end
      )
        return '';
      return this.action_filters.dates.end;
    },
  },
  watch: {
    show() {
      setTimeout(() => {
        if (this && this.$refs && this.$refs.scrollzone) {
          this.$refs.scrollzone.scrollTo(0, 0);
        }
      }, 1000);
    },
    selectedDates(newValue) {
      if (!newValue) {
        this.action_filters.dates = { start: null, end: null };
        return;
      }

      const arr = newValue.split(' to ');

      if (arr && arr.length === 2) {
        this.action_filters.dates = {
          start: moment(arr[0], 'D MMM YYYY').toISOString(),
          end: moment(arr[1], 'D MMM YYYY').toISOString(),
        };
      }
    },
    stored_filters(newValue) {
      this.action_filters = newValue;
    },
  },
  created() {
    if (this.filtered_start_date && this.filtered_end_date) {
      const start = moment(this.filtered_start_date).format('D MMM YYYY');
      const end = moment(this.filtered_end_date).format('D MMM YYYY');
      this.selectedDates = start + ' to ' + end;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.filters {
  position: fixed;
  top: 80px;
  right: -380px;
  transition: right 0.6s;
  border-left: 1px solid $border-color;

  height: calc(100% - 80px);
  width: 375px;
  background: #f9fafc;
  pointer-events: none;
  z-index: 800;

  .scroll-zone {
    overflow-y: auto;
    width: 100%;
    height: calc(100% - 100px);
    padding: 37px 25px;
  }

  &.active {
    right: 0;
    pointer-events: auto;
  }

  h4 {
    margin: 0;
    user-select: none;
  }

  .close {
    cursor: pointer;
    user-select: none;
    height: 24px;
    position: relative;
    right: -2px;
  }

  label {
    color: #26292f;
    font-size: 16px;
    font-weight: 500;
    margin-top: 40px;
    display: block;
  }

  ::v-deep .c-day-popover .popover-origin {
    display: none !important;
  }
}

.apply-filters {
  border-top: 1px solid #dbdee5;
  padding: 25px 0;
  margin: 0 25px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 50px);

  .button {
    width: 140px;
    min-width: 140px;
    margin: 0;
  }
}

.datepicker {
  width: 100%;

  ::v-deep .datepicker-input {
    width: 100%;
  }
}

.radio {
  display: inline-block;
  margin-right: 30px;
  cursor: pointer;
  padding-top: 15px;
  font-size: 14px;

  ::v-deep .custom-control-label {
    padding-left: 3px;
    padding-top: 3px;

    &:before {
      background-color: white !important;
      border: 1px solid #cad1d8;
      width: 18px;
      height: 18px;
      border-radius: 9px;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }
  }

  ::v-deep .custom-control-input:checked ~ .custom-control-label {
    user-select: none;
    &:before {
      background-image: none;
      border-color: #9cdccf;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }

    &:after {
      background-image: url('~@/assets/icons/green_check.png');
      background-position: 4px 4px;
      background-repeat: no-repeat;
      background-size: 10px 10px;
    }
  }
}
</style>
